import moment from "moment";
import StatusBadge from "../../../components/common/StatusBadge";

const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "File Number",
    dataIndex: "fileNumber",
    render: defaultRender,
  },
  {
    title: "File Name",
    dataIndex: "fileName",
    render: (value) => <p className="capitalize">{value}</p>,
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    render: (value) => moment(value).format("lll") || "--",
  },
  {
    title: "Source",
    dataIndex: "sign_source",
    render: (value) => (value ? <StatusBadge status={value} /> : "--"),
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (value) => (
      <p
        className={`font-bold uppercase ${
          value === "signed" ? "text-green-500" : "text-red-500"
        }`}
      >
        {value}
      </p>
    ),
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

export default columns;
